module.exports = __webpack_public_path__ + "static/doctor-1ff7b374377582d8a67e5d6fd06b131f.png";